export default (props, { colors, rhythm }) => ({
  root: {
    position: 'relative',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  slider: {
    flex: 'auto',
    height: rhythm(0.5),
    maxWidth: 250,
    margin: '1rem',
    backgroundColor: colors.shade,
    borderRadius: rhythm(0.25)
  },
  sliderHandle: {
    height: rhythm(1),
    width: rhythm(1),
    backgroundColor: colors.primary,
    borderRadius: rhythm(0.5),
    transform: `translateY(${rhythm(-0.25)})`,
    cursor: 'pointer'
  },
  control: {
    flex: '0 0 auto'
  }
})
